import { useEffect } from "react";

const siteUrl = "https://www.j3innovations.com";

const setMetaTag = (name, content, property = false) => {
  if (!content) return;
  const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    if (property) {
      tag.setAttribute("property", name);
    } else {
      tag.setAttribute("name", name);
    }
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setLinkTag = (rel, href) => {
  if (!href) return;
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
};

const Seo = ({
  title,
  description,
  canonicalPath,
  image = `${siteUrl}/logo192.png`,
  type = "website",
  structuredData,
}) => {
  useEffect(() => {
    if (title) document.title = title;
    const canonicalUrl = canonicalPath ? `${siteUrl}${canonicalPath}` : siteUrl;
    setMetaTag("description", description || "");
    setLinkTag("canonical", canonicalUrl);
    setMetaTag("og:title", title, true);
    setMetaTag("og:description", description || "", true);
    setMetaTag("og:type", type, true);
    setMetaTag("og:url", canonicalUrl, true);
    setMetaTag("og:image", image, true);
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", title || "");
    setMetaTag("twitter:description", description || "");
    setMetaTag("twitter:image", image);

    if (structuredData) {
      let scriptTag = document.getElementById("ld-json");
      if (!scriptTag) {
        scriptTag = document.createElement("script");
        scriptTag.type = "application/ld+json";
        scriptTag.id = "ld-json";
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(structuredData);
    }
  }, [title, description, canonicalPath, image, type, structuredData]);

  return null;
};

export default Seo;
